// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"2e1dfbdc","239":"80777251","732":"e66cbee8","777":"f5c3cc0e","977":"9c77bc56"}[chunkId] + ".chunk.js";
};